export const postcodeRegex: RegExp = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i

export const regPattern =
  /(^[A-Za-z]{2} ?[0-9]{2} ?[A-Za-z]{3} ?$)|(^[A-Za-z][0-9]{1,3} ?[A-Za-z]{3} ?$)|(^[A-Za-z]{3} ?[0-9]{1,3} ?[A-Za-z] ?$)|(^[0-9]{1,4} ?[A-Za-z]{1,2} ?$)|(^[0-9]{1,3} ?[A-Za-z]{1,3} ?$)|(^[A-Za-z]{1,2} ?[0-9]{1,4} ?$)|(^[A-Za-z]{1,3} ?[0-9]{1,3} ?$)|(^[A-Za-z]{1,3}[0-9]{1,4}$)/
